import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { i18nReady } from './i18n'
import { initWebVitals } from './utils/webVitals'
import App from './App.tsx'

// Await the initial locale chunks once before the first render — see
// i18n/index.ts for why this isn't done via React Suspense. index.html's
// #boot-skeleton is still visible underneath during this (typically
// sub-frame) gap, so there's no blank flash either way.
i18nReady.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  )
  initWebVitals()
})
